import {ValueObject} from '@s-ui/domain'

export class ModelsListValueObject extends ValueObject {
  /**
   * @param {Array} items
   * */
}
